import { isEmpty } from "../../appHelper";

export interface DeviceCommandRequest {
    systemId: string;
    name: string;
    requestJson: string;
    priority: boolean
}

export const initialDeviceCommandRequest: DeviceCommandRequest = {
    systemId: "",
    name: "",
    requestJson: '',
    priority: false
};

export const isDeviceCommandRequestValid = (request: DeviceCommandRequest) => {
    return !isEmpty(request.name) && !isEmpty(request.systemId) && !isEmpty(request.requestJson);
};

export interface DeviceCommand {
    afeCommandVersion: number;
    requestJson: string;
    name: string;
    priority: boolean;
    requestDate: string;
    responseJson: string;
    responseDate: string;
}

export interface DeviceCommandListResponse {
    responseCode: string;
    commands: DeviceCommand[];
}

